import React from "react";

const ListVoidReason = () => {
  return <div>list</div>;
};

export default ListVoidReason;
